import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import type {Resource} from "crqlar-react-common/dist/models/resource/resource.model";
import SingleDatePicker from "../../common/newDatePicker/SingleDatePicker";
import type {DatePickerChangeReason} from "../../common/newDatePicker/datePickerShared";
import ReadCanvasContainer from "./v2/ReadCanvasContainer";

interface FloorplanReadSurfaceProps {
    restaurant: Resource;
    date: Date;
    onDateChange: (date: Date, reason: DatePickerChangeReason) => void;
    desktopReservationsCollapsible?: boolean;
}

interface FloorplanReadHeaderControlsProps {
    date: Date;
    onDateChange: (date: Date, reason: DatePickerChangeReason) => void;
}

interface FloorplanReadCanvasProps {
    restaurant: Resource;
    date: Date;
    desktopReservationsCollapsible?: boolean;
}

export function FloorplanReadHeaderControls({
    date,
    onDateChange,
}: FloorplanReadHeaderControlsProps) {
    return (
        <SingleDatePicker
            value={date}
            onChange={onDateChange}
            showStepButtons
            size="medium"
        />
    );
}

export function FloorplanReadCanvas({
    restaurant,
    date,
    desktopReservationsCollapsible = false,
}: FloorplanReadCanvasProps) {
    return (
        <Box sx={{width: "100%", flex: 1, minHeight: 0}}>
            <ReadCanvasContainer
                restaurant={restaurant}
                date={date}
                desktopReservationsCollapsible={desktopReservationsCollapsible}
            />
        </Box>
    );
}

export function FloorplanReadSurface({
    restaurant,
    date,
    onDateChange,
    desktopReservationsCollapsible = false,
}: FloorplanReadSurfaceProps) {
    return (
        <Stack sx={{width: "100%", height: "100%", minHeight: 0}}>
            <Box
                sx={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    minHeight: {xs: 48, md: 92},
                    flexShrink: 0,
                    px: {xs: 1, md: 2},
                    boxSizing: "border-box",
                }}
            >
                <FloorplanReadHeaderControls date={date} onDateChange={onDateChange}/>
            </Box>

            <FloorplanReadCanvas
                restaurant={restaurant}
                date={date}
                desktopReservationsCollapsible={desktopReservationsCollapsible}
            />
        </Stack>
    );
}
